module.exports = __webpack_public_path__ + "img/barring_reselling_status.a8eef2d8.svg";